function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
import { DEFAULT_ACCOUNT_INFO } from "../utils/account";
import { TradingConfig } from "../utils/config";
import { translator } from "../utils/i18n";
import { DEFAULT_THEME } from "../utils/theme";
import { jsx as _jsx } from "react/jsx-runtime";
export var TradingGlobalContext = /*#__PURE__*/React.createContext({
  themeData: DEFAULT_THEME,
  accountInfo: DEFAULT_ACCOUNT_INFO,
  $st: translator.$st,
  $stn: translator.$stn,
  firstDataProvider: undefined,
  exchangeRate: {
    currency: "",
    exchangeRate: 1
  },
  showLoginDialog: function showLoginDialog() {},
  tickerMap: undefined,
  KycV2TradeKycModal: function KycV2TradeKycModal() {
    return {
      tradeKycModal: function tradeKycModal() {},
      tradeRight: false,
      loading: false
    };
  },
  SHOW_GA_BIND_GUIDE_REF: {
    showIfNeed: function showIfNeed() {
      return false;
    }
  }
});

/**
 * 使用交易组件处需要传入交易组件的全局配置，
 * @param children
 * @param resetProps
 * @constructor
 */
export var TradingGlobalProvider = function TradingGlobalProvider(_ref) {
  var children = _ref.children,
    resetProps = _objectWithoutProperties(_ref, _excluded);
  if (!TradingConfig.inited) {
    throw new Error("Please init trading config first!!!");
  }
  var $st = resetProps.$st,
    $stn = resetProps.$stn;
  translator.$st = $st;
  translator.$stn = $stn;
  return /*#__PURE__*/_jsx(TradingGlobalContext.Provider, {
    value: _objectSpread({}, resetProps),
    children: children
  });
};